import { getUserProfile } from "../api/auth/user";
import { store } from "../store";
import { userSettings } from "../store/slice/auth-slice";

/**
 * Re-reads the signed-in user's profile and replaces the stored copy, so plan
 * dates, credit balances, grace/lock state and pending notices are all current
 * (used after a payment, and when the server says the plan has ended).
 */
export const refreshProfile = async () => {
  const response = await getUserProfile();
  store.dispatch(
    userSettings({ ...response.data, token: localStorage.getItem("token") })
  );
};
